<template>
  <div class="student-panel">
    <!-- Modern Header -->
    <div class="panel-header">
      <div class="header-content">
        <div class="logo-section">
          <img src="@/assets/images/logo.png" alt="Modern Kurs Logo" class="header-logo" />
        </div>

      </div>
      <div class="header-actions">
        <a href="/kilavuzlar/ogrenci-kilavuz.pdf" target="_blank" rel="noopener" class="guide-link" title="Öğrenci Paneli Kullanım Kılavuzu">
          📖 Kullanım Kılavuzu
        </a>
        <div class="profile-info" @click="showProfileModal = true">
          <div class="profile-avatar">
            {{ getInitials(currentUser?.ad, currentUser?.soyad) }}
          </div>
          <div class="profile-details">
            <span class="profile-name">{{ currentUser?.ad }} {{ currentUser?.soyad }}</span>
            <span class="profile-role">Öğrenci</span>
          </div>
          <div class="profile-arrow">▼</div>
        </div>
      </div>
    </div>
    
    <div class="panel-content">
      <!-- Child Route'lar görüntülenirken ana panel içeriğini gizle -->
      <div v-if="!route.name || route.name === 'StudentPanel'">
        <div class="welcome-section">
      <div class="welcome-card">
            <div class="welcome-icon">🎓</div>
        <h2>Hoş Geldiniz!</h2>
        <p>Randevu almak veya mevcut randevularınızı görüntülemek için aşağıdaki seçenekleri kullanabilirsiniz.</p>
          </div>
      </div>
      
        <div class="action-section">
      <div class="action-cards">
                        <div class="action-card" @click="checkSystemStatusAndNavigate">
              <div class="card-icon">➕</div>
              <div class="card-content">
          <h3>Yeni Randevu Al</h3>
          <p>Ders seçerek yeni bir randevu oluşturun.</p>
              </div>
              <div class="card-arrow">→</div>
        </div>

            <div class="action-card" @click="toggleAppointments">
              <div class="card-icon">📅</div>
              <div class="card-content">
          <h3>Randevularım</h3>
                <p>Randevularınıza git</p>
        </div>
              <div class="card-arrow">↓</div>
      </div>

            <div class="action-card" @click="navigateToStatistics">
              <div class="card-icon">📊</div>
              <div class="card-content">
                <h3>İstatistiklerim</h3>
                <p>Randevu geçmişinizi ve haftalık istatistiklerinizi görüntüleyin.</p>
              </div>
              <div class="card-arrow">→</div>
            </div>
          </div>
        </div>

        <!-- Modern Randevular Bölümü -->
      <div v-if="showAppointments" class="appointments-section">
          <div class="section-header">
            <h2>📅 Randevularım</h2>
            <div class="section-stats">
              <span class="stat-badge">{{ appointments.length }} Randevu</span>
        </div>
            </div>
          
          <div v-if="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Randevular yükleniyor...</p>
          </div>
          
          <div v-else-if="appointments.length === 0" class="empty-state">
            <div class="empty-icon">📅</div>
            <h4>Henüz randevunuz bulunmamaktadır</h4>
            <p>İlk randevunuzu alarak başlayın</p>
          </div>
          
          <div v-else class="weekly-accordion">
            <div v-for="week in weeklyAppointments" :key="week.weekKey" class="week-accordion-item">
              <div class="accordion-header" @click="toggleWeek(week.weekKey)">
                <div class="week-info">
                  <span class="week-number">{{ week.weekNumber }}. Hafta</span>
                  <span class="week-date">{{ formatWeekDate(week.weekStart) }}</span>
                </div>
                <div class="week-summary">
                  <span class="total-count">{{ week.appointments.length }} randevu</span>
                  <div class="accordion-arrow" :class="{ 'expanded': expandedWeeks[week.weekKey] }">
                    ▼
                  </div>
                </div>
              </div>
              
              <div v-if="expandedWeeks[week.weekKey]" class="accordion-content">
                <div class="appointments-grid">
                  <div v-for="appointment in week.appointments" :key="appointment.id" class="appointment-card">
                    <div class="appointment-header">
                      <div class="lesson-icon">📚</div>
                      <div class="appointment-status">
                        <span :class="'status-badge status-' + appointment.status">
                          {{ getStatusText(appointment.status, appointment.cancelled_by) }}
                        </span>
                      </div>
                    </div>
                    
                    <div class="appointment-content">
                      <h4 class="lesson-name">{{ appointment.lesson?.name || 'Ders bilgisi yok' }}</h4>
                      <div class="appointment-info">
                        <div class="info-row">
                          <span class="info-label">Öğretmen:</span>
                          <span class="info-value">{{ getTeacherFullName(appointment.teacher_user_id) }}</span>
                        </div>
                        <div class="info-row">
                          <span class="info-label">🕐 Tarih/Saat:</span>
                          <span class="info-value">{{ formatDateTime(appointment.appointment_time) }}</span>
                        </div>
                      </div>
                    </div>
                    
            <div class="appointment-actions">
              <button 
                v-if="appointment.status !== 'iptal edildi' && appointment.status !== 'öğrenci katılmadı' && canCancelAppointment(appointment.appointment_time)" 
                @click="cancelAppointment(appointment.id)" 
                class="btn-cancel"
              >
                🗑️ İptal Et
              </button>
              <button 
                v-else-if="appointment.status !== 'iptal edildi' && appointment.status !== 'öğrenci katılmadı' && !canCancelAppointment(appointment.appointment_time)"
                class="btn-cancel disabled"
                disabled
                title="Randevu saati geçtiği için iptal edilemez"
              >
                ⏰ İptal Edilemez
              </button>
              <span v-else-if="appointment.status === 'iptal edildi'" class="cancelled-text">❌ İptal Edildi</span>
              <span v-else-if="appointment.status === 'öğrenci katılmadı'" class="cancelled-text">❌ Katılmadınız</span>
            </div>
          </div>
        </div>
              </div>
            </div>
          </div>
          
          <div class="section-actions">
            <button @click="showAppointments = false" class="btn-secondary">
              ✖️ Kapat
            </button>
          </div>
        </div>
      </div>
      

      
      <!-- Child Route'lar için Router View -->
      <router-view />
    </div>
    
    <!-- Sistem Durumu Modal -->
    <div v-if="showSystemStatusModal" class="modal-overlay" @click="showSystemStatusModal = false">
      <div class="modal-content system-status-modal" @click.stop>
        <div class="modal-header">
          <h3>🔄 Sistem Durumu</h3>
          <button @click="showSystemStatusModal = false" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <div class="system-status-content">
            <div v-if="systemStatus?.status === 'preparing'" class="status-preparing">
              <div class="status-icon">⏳</div>
              <h4>Sistem Hazırlanıyor</h4>
              <p>{{ systemStatus.message }}</p>
              <div class="countdown-timer">
                <span class="countdown-label">Açılışa Kalan:</span>
                <span class="countdown-value">{{ formatTimeUntilOpen(systemStatus.time_until_open) }}</span>
              </div>
              <div class="next-opening">
                <span class="opening-label">Sonraki Açılış:</span>
                <span class="opening-value">{{ formatDateTime(systemStatus.next_opening_time) }}</span>
              </div>
            </div>
            <div v-else-if="systemStatus?.status === 'maintenance'" class="status-maintenance">
              <div class="status-icon">🔧</div>
              <h4>Sistem Bakımda</h4>
              <p>{{ systemStatus.message }}</p>
            </div>
            <div v-else class="status-ready">
              <div class="status-icon">✅</div>
              <h4>Sistem Hazır</h4>
              <p>Randevu alma sistemi aktif. Hemen randevu alabilirsiniz!</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showSystemStatusModal = false" class="btn-secondary">Kapat</button>
          <button v-if="systemStatus?.status === 'ready'" @click="navigateToSelectLesson" class="btn-primary">Randevu Al</button>
        </div>
      </div>
    </div>

    <!-- Profil Modal -->
    <div v-if="showProfileModal" class="modal-overlay" @click="showProfileModal = false">
      <div class="modal-content profile-modal" @click.stop>
        <div class="modal-header">
          <h3>👤 Profil Bilgileri</h3>
          <button @click="showProfileModal = false" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <div class="profile-section">
            <div class="profile-avatar-large">
              {{ getInitials(currentUser?.ad, currentUser?.soyad) }}
            </div>
            <div class="profile-actions">
              <button @click="logout" class="logout-button">
                🚪 Çıkış Yap
              </button>
            </div>
            <div class="profile-info-details">
              <div class="info-row">
                <span class="info-label">Ad Soyad:</span>
                <span class="info-value">{{ currentUser?.ad }} {{ currentUser?.soyad }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Kullanıcı Adı:</span>
                <span class="info-value">{{ currentUser?.username }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Rol:</span>
                <span class="info-value"><span class="role-badge">Öğrenci</span></span>
              </div>
              <div class="info-row">
                <span class="info-label">Yeni Şifre:</span>
                <span class="info-value">
                  <div class="password-input-group">
                    <input 
                      v-model="newPassword" 
                      type="password" 
                      placeholder="Yeni şifre girin"
                      class="password-input"
                    />
                    <button @click="updatePassword" class="update-password-btn" :disabled="!newPassword || isUpdatingPassword">
                      <span v-if="!isUpdatingPassword">🔄 Güncelle</span>
                      <span v-else>⏳ Güncelleniyor...</span>
                    </button>
                  </div>
                </span>
              </div>
            </div>
          </div>
          
          <div class="profile-stats">
            <div class="stat-card">
              <div class="stat-icon">📅</div>
              <div class="stat-content">
                <span class="stat-label">Toplam Randevu</span>
                <span class="stat-number">{{ totalAppointments.length }}</span>
                
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">❌</div>
              <div class="stat-content">
                <span class="stat-label">İptal Edilen</span>
                <span class="stat-number">{{ cancelledAppointments.length }}</span>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">🚫</div>
              <div class="stat-content">
                <span class="stat-label">Katılmadığınız Randevu</span>
                <span class="stat-number">{{ absentAppointments.length }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Çıkış Onay Popup -->
  <div v-if="showLogoutConfirmPopup" class="logout-confirm-popup-overlay" @click="cancelLogout">
    <div class="logout-confirm-popup" @click.stop>
      <div class="logout-confirm-popup-header">
        <div class="logout-icon">🚪</div>
        <h3>Çıkış Onayı</h3>
      </div>
      <div class="logout-confirm-popup-body">
        <p>Çıkış yapmak istediğinizden emin misiniz?</p>
      </div>
      <div class="logout-confirm-popup-actions">
        <button @click="cancelLogout" class="btn-cancel">
          İptal
        </button>
        <button @click="confirmLogout" class="btn-logout-confirm">
          Evet, Çıkış Yap
        </button>
      </div>
    </div>
  </div>

  <!-- Randevu İptal Onay Popup -->
  <div v-if="showCancelAppointmentPopup" class="cancel-appointment-popup-overlay" @click="cancelCancelAppointment">
    <div class="cancel-appointment-popup" @click.stop>
      <div class="cancel-appointment-popup-header">
        <div class="cancel-icon">❌</div>
        <h3>Randevu İptal Onayı</h3>
      </div>
      <div class="cancel-appointment-popup-body">
        <div class="appointment-info">
          <p><strong>Ders:</strong> {{ cancelAppointmentData?.lessonName }}</p>
          <p><strong>Öğretmen:</strong> {{ cancelAppointmentData?.teacherName }}</p>
          <p><strong>Tarih:</strong> {{ cancelAppointmentData?.date }}</p>
        </div>
        <p class="warning-text">
          Bu randevuyu iptal etmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
        </p>
      </div>
      <div class="cancel-appointment-popup-actions">
        <button @click="cancelCancelAppointment" class="btn-cancel">
          İptal Etme
        </button>
        <button @click="confirmCancelAppointment" class="btn-cancel-confirm">
          Evet, İptal Et
        </button>
      </div>
    </div>

    <AppSuccessPopup :show="!!successPopup" :title="successTitle" :message="successPopup" @close="closeSuccessPopup" />
    <AppErrorModal :message="errorPopup" @close="closeErrorPopup" />
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import axios from 'axios'
import { isoWeek } from '@/utils/week'
import AppSuccessPopup from '@/components/AppSuccessPopup.vue'
import AppErrorModal from '@/components/AppErrorModal.vue'

export default {
  name: 'StudentPanel',
  components: { AppSuccessPopup, AppErrorModal },
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    
    const appointments = computed(() => store.getters.getAppointments || [])
    const showAppointments = ref(false)
    const isLoading = ref(false)
    const showProfileModal = ref(false)
    const refreshAvailability = ref(false)
    const expandedWeeks = ref({})

    // Bildirim popup'ları
    const successPopup = ref('')
    const successTitle = ref('Başarılı')
    const errorPopup = ref('')
    const pendingRedirect = ref(null)
    const closeSuccessPopup = () => {
      successPopup.value = ''
      successTitle.value = 'Başarılı'
    }
    const closeErrorPopup = () => {
      errorPopup.value = ''
      if (pendingRedirect.value) {
        const target = pendingRedirect.value
        pendingRedirect.value = null
        router.push(target)
      }
    }
    
    // Çıkış onay popup durumu
    const showLogoutConfirmPopup = ref(false)
    
    // Randevu iptal onay popup durumu
    const showCancelAppointmentPopup = ref(false)
    const cancelAppointmentData = ref(null)
    
    // Şifre güncelleme için ref'ler
    const newPassword = ref('')
    const isUpdatingPassword = ref(false)
    
    const currentUser = computed(() => store.getters.getCurrentUser)
    
    // Otomatik refresh için timer
    const autoRefreshTimer = ref(null)
    
    // Sistem durumu için ref'ler
    const showSystemStatusModal = ref(false)
    const systemStatus = ref(null)
    
    // Randevu istatistikleri
    const totalAppointments = computed(() => 
      appointments.value.filter(apt => apt.status === 'onaylandı')
    )
    
    const cancelledAppointments = computed(() => 
      appointments.value.filter(apt => apt.status === 'iptal edildi')
    )
    
    const absentAppointments = computed(() => 
      appointments.value.filter(apt => apt.status === 'öğrenci katılmadı')
    )

    // Haftalık randevu gruplama
    const weeklyAppointments = computed(() => {
      if (!appointments.value || appointments.value.length === 0) return []
      
      const weeklyGroups = {}
      
      appointments.value.forEach(appointment => {
        const appointmentTime = new Date(appointment.appointment_time)
        const weekStart = getWeekStartDate(appointmentTime)
        const weekNumber = getWeekNumber(appointmentTime)
        const year = appointmentTime.getFullYear()
        
        const weekKey = `${year}-${weekNumber}`
        
        if (!weeklyGroups[weekKey]) {
          weeklyGroups[weekKey] = {
            weekKey,
            weekNumber,
            weekStart,
            appointments: []
          }
        }
        
        weeklyGroups[weekKey].appointments.push(appointment)
      })
      
      // Haftaları sırala (en yeni önce)
      return Object.values(weeklyGroups).sort((a, b) => {
        if (a.year !== b.year) return b.year - a.year
        return b.weekNumber - a.weekNumber
      })
    })
    
    // Profil fonksiyonları
    const getInitials = (ad, soyad) => {
      if (!ad || !soyad) return '?'
      return `${ad.charAt(0)}${soyad.charAt(0)}`.toUpperCase()
    }
    
    const logout = async () => {
      // Çıkış onay popup'ını göster
      showLogoutConfirmPopup.value = true
    }

    const confirmLogout = async () => {
      try {
        await store.dispatch('logout')
        router.push('/login')
      } catch (error) {
        console.error('Çıkış yapılırken hata:', error)
        // Hata olsa bile login sayfasına yönlendir
        router.push('/login')
      } finally {
        showLogoutConfirmPopup.value = false
      }
    }

    const cancelLogout = () => {
      showLogoutConfirmPopup.value = false
    }
    
    // Şifre güncelleme fonksiyonu
    const updatePassword = async () => {
      if (!newPassword.value) {
        errorPopup.value = 'Şifre boş olamaz.'
        return
      }

      try {
        isUpdatingPassword.value = true

        const response = await axios.post('/api/users/me/change-password', {
          password: newPassword.value
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })

        if (response.data) {
          successTitle.value = '🔑 Şifre Güncellendi'
          successPopup.value = 'Şifreniz başarıyla güncellendi!'
          newPassword.value = ''
        }
      } catch (err) {
        console.error('Şifre güncellenirken hata:', err)
        errorPopup.value = `Şifre güncellenirken hata: ${err.response?.data?.error || 'Bilinmeyen hata'}`
      } finally {
        isUpdatingPassword.value = false
      }
    }

    // Haftalık accordion toggle
    const toggleWeek = (weekKey) => {
      expandedWeeks.value[weekKey] = !expandedWeeks.value[weekKey]
    }

    // Hafta başlangıç tarihi hesaplama
    const getWeekStartDate = (date) => {
      // Turkey timezone (+3) için tarihi ayarla
      const turkeyDate = new Date(date.toLocaleString("en-US", {timeZone: "Europe/Istanbul"}))
      
      // Pazar 19:00 kuralı: Pazar 19:00'dan sonra gelecek haftayı göster
      const isSundayAfter7PM = turkeyDate.getDay() === 0 && turkeyDate.getHours() >= 19
      
      if (isSundayAfter7PM) {
        // Pazar 19:00'dan sonra: Gelecek haftayı göster
        turkeyDate.setDate(turkeyDate.getDate() + 1) // Pazartesi'ye geç
      }
      
      const day = turkeyDate.getDay()
      const daysToMonday = day === 0 ? 6 : day - 1 // Pazar = 0, Pazartesi = 1
      const monday = new Date(turkeyDate)
      monday.setDate(turkeyDate.getDate() - daysToMonday)
      
      return monday
    }

    // Hafta numarası hesaplama — ISO 8601 (backend utils.ISOWeek ile birebir)
    // Yıl geçişinde eski "yılın ilk pazartesisi = W1" formülü tutarsızdı,
    // artık standart ISO 8601 kullanıyoruz.
    const getWeekNumber = (date) => {
      return isoWeek(date).week
    }

    // Hafta tarih formatı
    const formatWeekDate = (weekStart) => {
      if (!weekStart) return ''
      const date = new Date(weekStart)
      const endDate = new Date(date)
      endDate.setDate(date.getDate() + 6)
      
      return `${date.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit' })} - ${endDate.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit' })}`
    }

    // Öğrenci bilgilerini yükle
    const loadStudentInfo = async () => {
      try {
        // Önce token geçerliliğini kontrol et
        const isTokenValid = await store.dispatch('checkTokenValidity')
        if (!isTokenValid) {
          console.error('❌ Geçersiz token')
          router.push('/login')
          return
        }
        
        // Local storage'dan öğrenci bilgisini al
        const userStr = localStorage.getItem('user')
        if (userStr) {
          const userData = JSON.parse(userStr)
          
          // Rol kontrolü - sadece öğrenci erişebilir (backend'den gelen 'ogrenci' rolü)
          if (userData.role !== 'student' && userData.role !== 'ogrenci') {
            console.error('❌ Yetkisiz erişim: Öğrenci olmayan kullanıcı öğrenci paneline erişmeye çalışıyor')
            errorPopup.value = 'Bu sayfaya erişim yetkiniz bulunmamaktadır. Sadece öğrenciler erişebilir.'
            pendingRedirect.value = '/login'
            return
          }
          
          // Store'a öğrenci bilgisini set et
          store.commit('setCurrentUser', userData)

        } else {
          console.error('❌ Local storage\'da öğrenci bilgisi bulunamadı')
          // Login sayfasına yönlendir
          router.push('/login')
        }
      } catch (error) {
        console.error('❌ Öğrenci bilgileri yüklenirken hata:', error)
        router.push('/login')
      }
    }

    // Sistem durumunu yükle
    const loadSystemStatus = async () => {
      try {
        const response = await axios.get('https://api.modernkurs.com/api/system/status/user')
        if (response.data.success) {
          systemStatus.value = response.data

        } else {
          console.error('❌ Sistem durumu yüklenemedi:', response.data.message)
        }
      } catch (error) {
        // Axios Cancel hatası ise sessizce geç
        if (error.name === 'Cancel' || error.message?.includes('blocked')) {
          console.log('🚫 Sistem durumu yükleme iptal edildi:', error.message)
          return
        }
        console.error('❌ Sistem durumu yüklenirken hata:', error)
      }
    }

    // Sistem durumunu güncelle (admin panel'deki gibi)
    const updateSystemStatus = (newStatus) => {
      systemStatus.value = newStatus
    }

    // Sistem durumu değiştiğinde otomatik güncelleme (admin panel'deki gibi)
    watch(systemStatus, (newStatus) => {
      if (newStatus && newStatus.status === 'preparing') {
        
      }
    }, { deep: true })

    // Sistem durumu otomatik yenileme (admin panel'deki gibi)
    let systemStatusInterval = null
    
    const startSystemStatusRefresh = () => {
      if (systemStatusInterval) {
        clearInterval(systemStatusInterval)
      }
      
      systemStatusInterval = setInterval(async () => {
        if (systemStatus.value && systemStatus.value.status === 'preparing') {
          await loadSystemStatus()
        }
      }, 10000) // 10 saniyede bir güncelle
    }
    
    const stopSystemStatusRefresh = () => {
      if (systemStatusInterval) {
        clearInterval(systemStatusInterval)
        systemStatusInterval = null
      }
    }

    // Sistem durumu hazır olduğunda otomatik yenilemeyi durdur (admin panel'deki gibi)
    watch(systemStatus, (newStatus) => {
      if (newStatus && newStatus.status === 'ready') {
        
        stopSystemStatusRefresh()
      } else if (newStatus && newStatus.status === 'preparing') {
        
        startSystemStatusRefresh()
        
        // 🚨 Güvenlik önlemi: Randevu alma sürecindeyse bakım sayfasına yönlendir
        checkAndRedirectFromBookingProcess()
      }
    }, { deep: true })

    // Randevu alma sürecindeki sayfaları kontrol et ve güvenlik önlemi uygula
    const checkAndRedirectFromBookingProcess = () => {
      const currentRoute = route.name
      const bookingPages = [
        'SelectLesson',     // Ders seçimi
        'SelectTeacher',    // Hoca seçimi  
        'SelectTime'        // Saat seçimi
      ]
      
      
      
      if (bookingPages.includes(currentRoute)) {
        
        
        // Kullanıcıyı bilgilendir
        errorPopup.value = 'Sistem bakım moduna alındı. Ana sayfaya yönlendiriliyorsunuz.'
        pendingRedirect.value = '/student'
        
        // Sistem durumu modal'ını göster
        showSystemStatusModal.value = true
      }
    }

    onMounted(async () => {
      // Önce route kontrolü yap - sadece öğrenci panelinde çalışsın
      if (router.currentRoute.value.path !== '/panel/ogrenci') {
        return
      }
      
      // Öğrenci bilgilerini yükle
      await loadStudentInfo()
      
      // Sadece currentUser varsa API istekleri yap
      if (currentUser.value) {
        // Hocaları ve randevuları yükle
        await store.dispatch('fetchTeachers')
      await fetchAppointments()
        
        // Sistem durumunu yükle
        await loadSystemStatus()
        
        // Sistem durumu otomatik yenilemeyi başlat (admin panel'deki gibi)
        if (systemStatus.value && systemStatus.value.status === 'preparing') {
          startSystemStatusRefresh()
          
          // 🚨 Güvenlik önlemi: Sayfa yüklendiğinde de randevu alma sürecini kontrol et
          checkAndRedirectFromBookingProcess()
        }
      }
      
      // Randevular bölümü başlangıçta açık olsun
      showAppointments.value = true
      
      // Sayfa focus olduğunda kullanıcı bilgilerini kontrol et
      window.addEventListener('focus', handleWindowFocus)
    })
    
    // Component unmount olduğunda event listener'ı temizle
    onUnmounted(() => {
      window.removeEventListener('focus', handleWindowFocus)
      // Sistem durumu otomatik yenilemeyi durdur (admin panel'deki gibi)
      stopSystemStatusRefresh()
    })

    // Haftalık randevular değiştiğinde sadece son haftayı aç
    watch(weeklyAppointments, (newWeeklyAppointments) => {
      if (newWeeklyAppointments.length > 0 && showAppointments.value) {
        // Önce tüm haftaları kapat
        Object.keys(expandedWeeks.value).forEach(weekKey => {
          expandedWeeks.value[weekKey] = false
        })
        
        // Son haftayı bul (en yeni hafta) ve aç
        const lastWeek = newWeeklyAppointments[0]
        if (lastWeek) {
          expandedWeeks.value[lastWeek.weekKey] = true
  
        }
      }
    }, { immediate: false })

    // 🚨 Route değişikliklerini dinle - güvenlik önlemi için
    watch(() => route.name, (newRouteName) => {
      
      
      // Sistem hazırlanıyor durumdayken randevu alma sürecindeki sayfalara erişimi engelle
      if (systemStatus.value && systemStatus.value.status === 'preparing') {
        checkAndRedirectFromBookingProcess()
      }
    })
    
    // Sayfa focus olduğunda çalışacak fonksiyon
    const handleWindowFocus = async () => {
      // Token geçerliliğini kontrol et
      const isTokenValid = await store.dispatch('checkTokenValidity')
      if (!isTokenValid) {
        
        router.push('/login')
        return
      }
      
      // Kullanıcı rolünü tekrar kontrol et
      const currentUser = store.getters.getCurrentUser
      if (currentUser && currentUser.role !== 'student' && currentUser.role !== 'ogrenci') {
        
        errorPopup.value = 'Bu sayfaya erişim yetkiniz bulunmamaktadır.'
        pendingRedirect.value = '/login'
        return
      }
    }

    const fetchAppointments = async () => {
      isLoading.value = true
      
      // Mevcut kullanıcı ID'sini al
      const currentUser = store.getters.getCurrentUser

      
      if (currentUser?.id) {

        const result = await store.dispatch('fetchAppointments', currentUser.id)

        
        // Randevular her zaman gösterilsin
        const currentAppointments = store.getters.getAppointments || []

        
        if (currentAppointments.length > 0) {
          showAppointments.value = true

          
          // Son haftayı da otomatik aç (diğerlerini kapatarak)
          setTimeout(() => {
            if (weeklyAppointments.value.length > 0) {
              // Önce tüm haftaları kapat
              Object.keys(expandedWeeks.value).forEach(weekKey => {
                expandedWeeks.value[weekKey] = false
              })
              
              // Son haftayı bul (en yeni hafta) ve aç
              const lastWeek = weeklyAppointments.value[0]
              if (lastWeek) {
                expandedWeeks.value[lastWeek.weekKey] = true

              }
            }
          }, 100) // Haftalık gruplama hesaplanması için kısa bir bekleme
        }
      } else {
        // currentUser yoksa sessizce çık
      }
      
      isLoading.value = false
    }

    const toggleAppointments = () => {
      // Randevular her zaman açık kalsın
      showAppointments.value = true
      
      // Randevular bölümüne yumuşak kaydırma yap
      setTimeout(() => {
        const appointmentsSection = document.querySelector('.appointments-section')
        if (appointmentsSection) {
          appointmentsSection.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          })
        }
      }, 100)
      
      // Eğer randevular varsa, tüm haftaları kapat ve sadece son haftayı aç
      if (weeklyAppointments.value.length > 0) {
        // Önce tüm haftaları kapat
        Object.keys(expandedWeeks.value).forEach(weekKey => {
          expandedWeeks.value[weekKey] = false
        })
        
        // Son haftayı bul (en yeni hafta) ve aç
        const lastWeek = weeklyAppointments.value[0]
        if (lastWeek) {
          expandedWeeks.value[lastWeek.weekKey] = true

        }
      }
    }

    const navigateTo = (route) => {
      // Nested route'lar için öğrenci paneli altında yönlendir
      if (route === 'SelectLesson') {
        router.push('/panel/ogrenci/select-lesson')
      } else {
      router.push({ name: route })
    }
    }
    // Sistem durumu kontrolü ve randevu alma
    const checkSystemStatusAndNavigate = async () => {
      try {
        const response = await axios.get('https://api.modernkurs.com/api/system/status/user')
        if (response.data.success) {
          systemStatus.value = response.data
          
          if (response.data.can_book) {
            // 🚨 Güvenlik önlemi: Randevu almaya çalışırken sistem durumunu kontrol et

            navigateTo('SelectLesson')
          } else {
            // Sistem hazır değil, modal'ı göster

            showSystemStatusModal.value = true
          }
        } else {
          console.error('Sistem durumu alınamadı:', response.data.error)
          // Hata durumunda sistem durumu modal'ını göster
          showSystemStatusModal.value = true
        }
      } catch (error) {
        // Axios Cancel hatası ise sessizce geç
        if (error.name === 'Cancel' || error.message?.includes('blocked')) {
          console.log('🚫 Sistem durumu kontrol iptal edildi:', error.message)
          return
        }
        console.error('Sistem durumu kontrol hatası:', error)
        // Hata durumunda sistem durumu modal'ını göster
        showSystemStatusModal.value = true
      }
    }

    const navigateToSelectLesson = () => {
      showSystemStatusModal.value = false
      navigateTo('SelectLesson')
    }

    const navigateToStatistics = () => {
      router.push('/panel/ogrenci/statistics')
    }

    // Otomatik refresh fonksiyonu - dakika başlarında randevuları yeniler
    const startAutoRefresh = () => {
      const scheduleNextRefresh = () => {
        const now = new Date()
        const nextMinute = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + 1, 0, 0)
        const delay = nextMinute.getTime() - now.getTime()
        

        
        // Dakika başında refresh yap
        setTimeout(async () => {
  
          
          // Mevcut scroll pozisyonunu kaydet
          const currentScrollPosition = window.scrollY
          
          await fetchAppointments()
          
          // Refresh sonrası scroll pozisyonunu geri yükle
          setTimeout(() => {
            window.scrollTo(0, currentScrollPosition)
    
          }, 100)
          
          // Sonraki dakika için tekrar planla
          scheduleNextRefresh()
        }, delay)
      }
      
      // İlk refresh'i planla
      scheduleNextRefresh()
    }

    // Otomatik refresh'i durdur
    const stopAutoRefresh = () => {
      if (autoRefreshTimer.value) {
        clearTimeout(autoRefreshTimer.value)
        autoRefreshTimer.value = null

      }
    }



    const cancelAppointment = async (id) => {
      // İptal edilecek randevunun bilgilerini al
      const appointmentToCancel = appointments.value.find(apt => apt.id === id)
      if (!appointmentToCancel) {
        console.error('İptal edilecek randevu bulunamadı')
        return
      }

      // Randevu iptal onay popup'ını göster
      cancelAppointmentData.value = {
        id,
        lessonName: appointmentToCancel.lesson?.name || 'Ders',
        teacherName: getTeacherFullName(appointmentToCancel.teacher_user_id),
        date: formatDateTime(appointmentToCancel.appointment_time)
      }
      showCancelAppointmentPopup.value = true
    }

    const confirmCancelAppointment = async () => {
      if (!cancelAppointmentData.value) return
      
      try {
        const result = await store.dispatch('updateAppointmentStatus', { 
          appointmentId: cancelAppointmentData.value.id, 
          status: 'iptal edildi',
          cancelledBy: 'student'
        })
        
        if (result.success) {
          // Randevuları yeniden yükle
          await fetchAppointments()
          
          // Müsaitlik takvimini yenile
          refreshAvailability.value = true
          setTimeout(() => {
            refreshAvailability.value = false
          }, 100)
          
          // Randevu iptal edildikten sonra sadece son hafta açık kalsın
          setTimeout(() => {
            if (weeklyAppointments.value.length > 0) {
              // Önce tüm haftaları kapat
              Object.keys(expandedWeeks.value).forEach(weekKey => {
                expandedWeeks.value[weekKey] = false
              })
              
              // Son haftayı bul (en yeni hafta) ve aç
              const lastWeek = weeklyAppointments.value[0]
              if (lastWeek) {
                expandedWeeks.value[lastWeek.weekKey] = true
        
              }
            }
          }, 200) // FetchAppointments tamamlandıktan sonra
          
          // Popup'ı kapat
          showCancelAppointmentPopup.value = false
          cancelAppointmentData.value = null
        } else {
          console.error('Randevu iptal edilemedi:', result.error)
        }
      } catch (err) {
        console.error('Randevu iptal edilirken hata:', err)
      }
    }

    const cancelCancelAppointment = () => {
      showCancelAppointmentPopup.value = false
      cancelAppointmentData.value = null
    }

    const formatDateTime = (dateTimeStr) => {
      if (!dateTimeStr) return 'Tarih bilgisi yok'
      
      const date = new Date(dateTimeStr)
      return new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date)
    }

    // Sistem durumu yardımcı fonksiyonları
    const formatTimeUntilOpen = (timeUntilOpen) => {
      if (!timeUntilOpen) return 'Hesaplanıyor...'
      
      try {
        // Debug log

        
        // Backend'den gelen minutes_until_open ve seconds_until_open değerlerini kullan
        // Bu değerler zaten doğru hesaplanmış
        if (systemStatus.value && systemStatus.value.minutes_until_open !== undefined) {
          const minutes = systemStatus.value.minutes_until_open
          const totalSeconds = systemStatus.value.seconds_until_open || 0
          
          // Toplam saniyeyi dakika ve saniyeye çevir
          const actualMinutes = Math.floor(totalSeconds / 60)
          const actualSeconds = totalSeconds % 60
          
          
          
          if (actualMinutes > 0) {
            return `${actualMinutes} dakika ${actualSeconds} saniye`
          } else {
            return `${actualSeconds} saniye`
          }
        }
        
        // Eski yöntem (fallback)
        let diffInMs = 0
        
        if (typeof timeUntilOpen === 'number') {
          diffInMs = timeUntilOpen
        } else {
          console.error('❌ Beklenmeyen timeUntilOpen tipi:', typeof timeUntilOpen)
          return 'Süre tipi hatası'
        }
        

        
        if (diffInMs <= 0) {
          return 'Açılış zamanı geldi!'
        }
        
        // Makul süre kontrolü (24 saat = 1440 dakika)
        if (diffInMs > 24 * 60 * 60 * 1000) {
          console.error('❌ Çok uzun süre:', diffInMs, 'ms')
          return 'Süre hesaplanamadı'
        }
        
        const minutes = Math.floor(diffInMs / 60000)
        const seconds = Math.floor((diffInMs % 60000) / 1000)
        

        
        if (minutes > 0) {
          return `${minutes} dakika ${seconds} saniye`
        } else {
          return `${seconds} saniye`
        }
      } catch (error) {
        console.error('❌ formatTimeUntilOpen hatası:', error)
        return 'Hesaplama hatası'
      }
    }

    // Randevunun iptal edilebilir olup olmadığını kontrol eder
    const canCancelAppointment = (appointmentTime) => {
      if (!appointmentTime) return false
      
      const now = new Date()
      const appointmentDate = new Date(appointmentTime)
      
      // Randevu saati geçmişse veya randevu anı geldiyse iptal edilemez
      // 1 dakika tolerans veriyoruz (randevu başladıktan 1 dakika sonra iptal edilemez)
      const oneMinuteLater = new Date(appointmentDate.getTime() + 60000)
      
      return now < oneMinuteLater
    }

    const goHome = () => {
      router.push('/')
    }
    
    const goToStudentPanel = () => {
      router.push('/panel/ogrenci')
    }
    
    const getCurrentPageTitle = () => {
      switch (route.name) {
        case 'StudentSelectLesson':
          return 'Ders Seçimi'
        case 'StudentSelectTeacher':
          return 'Öğretmen Seçimi'
        case 'StudentSelectTime':
          return 'Saat Seçimi'
        default:
          return 'Bilinmeyen Sayfa'
      }
    }

    // Hoca adı ve soyadını getir
    const getTeacherFullName = (teacherUserId) => {
      if (!teacherUserId) return 'Öğretmen bilgisi yok'
      
      // Hocalar listesinden bul
      const teachers = store.state.teachers || []
      const teacher = teachers.find(t => t.id === teacherUserId)
      
      if (teacher) {
        return `${teacher.ad} ${teacher.soyad}`
      }
      
      return 'Öğretmen bilgisi yok'
    }

    // Durum metnini Türkçe yap ve iptal eden bilgisini ekle
    const getStatusText = (status, cancelledBy) => {
      if (status === 'iptal edildi') {
        if (cancelledBy === 'admin') {
          return 'Öğretmen tarafından iptal edildi'
        } else if (cancelledBy === 'student') {
          return 'İptal ettiniz'
        } else {
          return 'İptal Edildi'
        }
      }
      
      const statusMap = {
        'beklemede': 'Beklemede',
        'onaylandı': 'Onaylandı',
        'öğrenci katılmadı': 'Katılmadınız'
      }
      
      return statusMap[status] || status
    }

    // Component mount olduğunda otomatik refresh'i başlat
    onMounted(() => {
      // İlk randevu yüklemesi
      loadStudentInfo()
      
      // Otomatik refresh'i başlat
      startAutoRefresh()
      
      
    })

    // Component unmount olduğunda timer'ı temizle
    onUnmounted(() => {
      stopAutoRefresh()
      
    })

    return {
      appointments,
      showAppointments,
      isLoading,
      showProfileModal,
      successPopup,
      successTitle,
      errorPopup,
      closeSuccessPopup,
      closeErrorPopup,
      showLogoutConfirmPopup,
      showCancelAppointmentPopup,
      cancelAppointmentData,
      currentUser,
      totalAppointments,
      cancelledAppointments,
      absentAppointments,
      weeklyAppointments,
      expandedWeeks,
      route, // Route objesini template'e expose et
      getInitials,
      logout,
      confirmLogout,
      cancelLogout,
      // Şifre güncelleme
      newPassword,
      isUpdatingPassword,
      updatePassword,
      loadStudentInfo,
      handleWindowFocus,
      toggleAppointments,
      navigateTo,
      navigateToStatistics,
      checkSystemStatusAndNavigate,
      navigateToSelectLesson,
      cancelAppointment,
      confirmCancelAppointment,
      cancelCancelAppointment,
      formatDateTime,
      formatTimeUntilOpen,
      canCancelAppointment,
      goHome,
      goToStudentPanel,
      getCurrentPageTitle,
      getTeacherFullName,
      getStatusText,
      toggleWeek,
      formatWeekDate,
      showSystemStatusModal,
      systemStatus,
      // Sistem durumu güncelleme fonksiyonları (admin panel'deki gibi)
      loadSystemStatus,
      updateSystemStatus,
      startSystemStatusRefresh,
      stopSystemStatusRefresh,
      // Güvenlik önlemi fonksiyonu
      checkAndRedirectFromBookingProcess
    }
  }
}
</script>

<style scoped>
.student-panel {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: white !important;
  color: #333 !important;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}



.logo-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-left: -2rem;
}

.header-logo {
  width: 500px;
  height: 130px;
  object-fit: contain;
}

.header-actions {
  display: flex;
  align-items: center;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  background: #f8f9fa;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #e9ecef;
}

.profile-info:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.profile-avatar {
  width: 40px;
  height: 40px;
  background: #667eea;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: white;
}

.profile-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.profile-name {
  font-weight: 600;
  font-size: 1rem;
  color: #333;
}

.profile-role {
  font-size: 0.9rem;
  color: #666;
}

.profile-arrow {
  font-size: 0.8rem;
  color: #666;
  transition: transform 0.3s;
}

  .profile-info:hover .profile-arrow {
    transform: rotate(180deg);
  }
  
  /* Profil Modal Stilleri */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    border-radius: 16px;
    max-width: 600px; /* Admin panel ile hizala */
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    animation: modalSlideIn 0.3s ease-out;
  }
  
  @keyframes modalSlideIn {
    from {
      opacity: 0;
      transform: translateY(-20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2rem;
    border-bottom: 1px solid #f0f0f0;
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
    color: white;
    border-radius: 16px 16px 0 0;
  }
  
  .modal-header h3 {
  margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
  }
  
  .modal-close {
    background: none;
    border: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 50%;
    transition: background-color 0.3s;
  }
  
  .modal-close:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  /* Sistem Durumu Modal Stilleri */
  .system-status-modal .modal-content {
    max-width: 600px;
  }

  .system-status-content {
    text-align: center;
    padding: 1rem 0;
  }

  .status-icon {
    font-size: 4rem;
    margin-bottom: 1rem;
  }

  .status-preparing h4 {
    color: #f57c00;
    margin-bottom: 1rem;
  }

  .status-maintenance h4 {
    color: #d32f2f;
    margin-bottom: 1rem;
  }

  .status-ready h4 {
    color: #388e3c;
    margin-bottom: 1rem;
  }

  .countdown-timer {
    background: #fff3e0;
    padding: 1rem;
    border-radius: 12px;
    margin: 1rem 0;
    border: 2px solid #ffb74d;
  }

  .countdown-label {
    display: block;
    font-weight: 600;
    color: #f57c00;
    margin-bottom: 0.5rem;
  }

  .countdown-value {
    font-family: monospace;
    font-size: 1.5rem;
    font-weight: bold;
    color: #f57c00;
  }

  .next-opening {
    background: #e3f2fd;
    padding: 1rem;
    border-radius: 12px;
    margin: 1rem 0;
    border: 2px solid #64b5f6;
  }

  .opening-label {
    display: block;
    font-weight: 600;
    color: #1976d2;
    margin-bottom: 0.5rem;
  }

  .opening-value {
    font-family: monospace;
    font-size: 1.2rem;
    color: #1976d2;
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    border-top: 1px solid #f0f0f0;
    gap: 1rem;
  }

  .btn-primary {
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
  }

  .btn-secondary {
    background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
  }

  .btn-secondary:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
  }
  
  .modal-body {
    padding: 2rem;
  }
  
  .profile-section {
    text-align: center;
    margin-bottom: 2rem;
  }
  
  .profile-avatar-large {
    width: 100px;
    height: 100px;
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.5rem;
    font-weight: bold;
    color: white;
    margin: 0 auto 1.5rem;
    box-shadow: 0 8px 20px rgba(33, 150, 243, 0.4);
  }
  
  .profile-info-grid {
    display: grid;
    gap: 1rem;
    text-align: left;
    max-width: 520px; /* İçeriği daralt ve ortala */
    margin: 0 auto;
  }

  /* Teacher/Admin panel ile uyumlu bilgi satırları */
  .profile-info-details {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 520px;
    margin: 0 auto 1.5rem;
  }
  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 10px;
    text-align: left;
  }
  .info-label {
    font-weight: 600;
    color: #495057;
    min-width: 120px;
    text-align: left;
  }
  .info-value {
    color: #212529;
    font-weight: 500;
    text-align: left;
  }
  
  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #2196F3;
  }
  
  .info-item label {
    font-weight: 600;
    color: #495057;
    min-width: 120px;
  }
  
  .info-item span {
    color: #212529;
    font-weight: 500;
  }
  
  .role-badge {
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 600;
  }
  
  /* Şifre güncelleme stilleri */
  .password-input-group {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    flex: 1;
  }
  
  .password-input {
    flex: 1;
    padding: 0.5rem 0.75rem;
    border: 2px solid #e9ecef;
    border-radius: 6px;
    font-size: 0.9rem;
    transition: border-color 0.3s;
  }
  
  .password-input:focus {
    outline: none;
    border-color: #2196F3;
  }
  
  .update-password-btn {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
  }
  
  .update-password-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  }
  
  .update-password-btn:disabled {
    background: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  .profile-stats {
    display: grid;
    grid-template-columns: 1fr; /* İstatistikler alt alta */
    gap: 1rem;
    margin: 0 auto 2rem; /* Ortala ve alt boşluk koru */
    min-width: 0; /* Grid taşmasını önle */
    width: 100%;
    max-width: 520px; /* AdminPanel ile benzer içerik genişliği */
  }
  
  .stat-card {
    background: #f8f9fa;
    border-radius: 12px; /* Admin panel ile uyumlu */
    padding: 1rem;
    text-align: center;
    border: 1px solid #e9ecef;
    transition: transform 0.3s, box-shadow 0.3s;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 0; /* İçerik taşmasını önle */
    overflow: hidden;
  }
  
  .stat-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  }
  
  .stat-icon {
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
  }
  
  .stat-number {
    display: block;
    font-size: 1.25rem;
    font-weight: bold;
    color: #2196F3;
    margin-bottom: 0.25rem;
  }
  
  .stat-label {
    font-size: 0.8rem;
    color: #6c757d;
    font-weight: 500;
    line-height: 1.2;
  }
  
  .profile-actions {
    text-align: center;
  }
  
  .logout-button {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    color: white;
    border: none;
    padding: 1rem 2rem;
    border-radius: 25px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
    margin-bottom: 12px; /* Alt boşluğu hafif artırıldı */
  }
  
  .logout-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
  }
  
  /* Responsive tasarım */
  @media (max-width: 1024px) {
    .profile-stats {
      grid-template-columns: 1fr; /* Tablet ve altı: alt alta */
      gap: 0.75rem;
    }
    
    .stat-card {
      padding: 0.875rem;
      min-height: 70px;
    }
    
    .stat-icon {
      font-size: 1.25rem;
    }
    
    .stat-number {
      font-size: 1.1rem;
    }
    
    .stat-label {
      font-size: 0.75rem;
    }
  }
  
  @media (max-width: 768px) {
    .modal-content {
      width: 95%;
      margin: 1rem;
      max-height: 85vh;
      border-radius: 12px;
    }
    
    .modal-header {
      padding: 1rem 1.5rem;
      border-radius: 12px 12px 0 0;
    }
    
    .modal-header h3 {
      font-size: 1.25rem;
    }
    
    .modal-body {
      padding: 1.5rem;
    }
    
    .profile-avatar-large {
      width: 80px;
      height: 80px;
      font-size: 2rem;
      margin-bottom: 1rem;
    }
    
    .profile-info-grid {
      gap: 0.75rem;
    }
    
    .info-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
      padding: 0.75rem;
    }
    
    .info-item label {
      min-width: auto;
      font-size: 0.9rem;
    }
    
    .info-item span {
      font-size: 0.9rem;
    }
    
    .password-input-group {
      flex-direction: column;
      align-items: stretch;
      gap: 0.5rem;
    }
    
    .password-input {
      width: 100%;
    }
    
    .update-password-btn {
      width: 100%;
      padding: 0.75rem 1rem;
    }
    
    .profile-stats {
      grid-template-columns: 1fr; /* Alt alta */
      gap: 0.5rem;
    }
    
    .stat-card {
      padding: 0.75rem;
      min-height: 65px;
    }
    
    .stat-icon {
      font-size: 1.1rem;
      margin-bottom: 0.2rem;
    }
    
    .stat-number {
      font-size: 1rem;
      margin-bottom: 0.2rem;
    }
    
    .stat-label {
      font-size: 0.7rem;
    }
  }
  
  @media (max-width: 480px) {
    .modal-content {
      width: 98%;
      margin: 0.5rem;
      max-height: 90vh;
      border-radius: 8px;
    }
    
    .modal-header {
      padding: 0.75rem 1rem;
      border-radius: 8px 8px 0 0;
    }
    
    .modal-header h3 {
      font-size: 1.1rem;
    }
    
    .modal-body {
      padding: 1rem;
    }
    
    .profile-avatar-large {
      width: 70px;
      height: 70px;
      font-size: 1.75rem;
      margin-bottom: 0.75rem;
    }
    
    .profile-info-grid {
      gap: 0.5rem;
    }
    
    .info-item {
      padding: 0.5rem;
    }
    
    .info-item label {
      font-size: 0.8rem;
    }
    
    .info-item span {
      font-size: 0.8rem;
    }
    
    .profile-stats {
      grid-template-columns: 1fr; /* Alt alta */
      gap: 0.5rem;
    }
    
    .stat-card {
      padding: 0.75rem;
      min-height: 60px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      text-align: left;
    }
    
    .stat-icon {
      font-size: 1rem;
      margin-bottom: 0;
      margin-right: 0.5rem;
    }
    
    .stat-content {
      flex: 1;
      text-align: left;
    }
    
    .stat-number {
      font-size: 1rem;
      margin-bottom: 0.1rem;
    }
    
    .stat-label {
      font-size: 0.7rem;
    }
  }
  
  @media (max-width: 360px) {
    .profile-stats {
      grid-template-columns: 1fr;
      gap: 0.5rem;
    }
    
    .stat-card {
      padding: 0.75rem;
      min-height: 60px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      text-align: left;
    }
    
    .stat-icon {
      font-size: 1rem;
      margin-bottom: 0;
      margin-right: 0.5rem;
    }
    
    .stat-content {
      flex: 1;
      text-align: left;
    }
    
    .stat-number {
      font-size: 1rem;
      margin-bottom: 0.1rem;
    }
    
    .stat-label {
      font-size: 0.7rem;
    }
    
    .info-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }
    
    .info-item label {
      min-width: auto;
    }
    
    .password-input-group {
      flex-direction: column;
      align-items: stretch;
      gap: 0.5rem;
    }
    
    .password-input {
      width: 100%;
    }
    
    .update-password-btn {
      width: 100%;
      padding: 0.75rem 1rem;
    }
}

.home-button {
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.home-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.panel-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.welcome-card {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.welcome-card h2 {
  color: #2196F3;
  margin-bottom: 1rem;
}

.welcome-card p {
  color: #666;
  margin-bottom: 0.5rem;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.feature-card {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.feature-card h3 {
  color: #333;
  margin-bottom: 1rem;
}

.feature-card p {
  color: #666;
  margin: 0;
}

.action-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.card {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.appointments-section {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 2rem;
}

.appointments-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  margin: 1.5rem 0;
}

.appointment-card {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.appointment-details h4 {
  margin-top: 0;
  color: #333;
}

.appointment-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
}

.cancel-button {
  padding: 0.5rem 1rem;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.close-button {
  padding: 0.75rem 1.5rem;
  background-color: #ccc;
  border: none;
  border-radius: 4px;
  margin-top: 1rem;
  cursor: pointer;
}

.loading, .no-data {
  text-align: center;
  padding: 2rem;
  color: #666;
}

.status-beklemede {
  color: #ff9800;
}

.status-onaylandı {
  color: #4CAF50;
}

.status-iptal {
  color: #f44336;
}

.status-iptal-edildi {
  color: #f44336;
}

.status-öğrenci\ katılmadı {
  background: #f8d7da;
  color: #721c24;
}

.cancelled-text {
  color: #f44336;
  font-style: italic;
  font-size: 0.9rem;
}

.cancel-button:hover {
  background-color: #d32f2f;
  transform: translateY(-1px);
  transition: all 0.2s ease;
}

/* Breadcrumb Styles */
.breadcrumb {
  display: flex;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 2rem;
}



/* Modern Student Panel Styles */
.student-panel {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.panel-header {
  background: white !important;
  color: #333 !important;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content h1 {
  margin: 0 0 0.5rem 0;
  font-size: 2.5rem;
  font-weight: 700;
}

.header-subtitle {
  margin: 0;
  opacity: 0.9;
  font-size: 1.1rem;
}

.header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 0;
}

.guide-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  color: #2c3e50;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 25px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.3s;
  white-space: nowrap;
  min-height: calc(45px + 2rem); /* profile-avatar (45px) + padding — profil butonuyla eş yükseklik */
}

.guide-link:hover {
  background: rgba(76, 175, 80, 0.15);
  border-color: #4CAF50;
  color: #2e7d32;
  transform: translateY(-1px);
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
}

.profile-info:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.profile-avatar {
  width: 45px;
  height: 45px;
  background: #667eea;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
}

.profile-details {
  display: flex;
  flex-direction: column;
}

.profile-name {
  font-weight: 600;
  font-size: 1rem;
}

.profile-role {
  font-size: 0.9rem;
  opacity: 0.8;
}

.profile-arrow {
  font-size: 1.2rem;
  transition: transform 0.3s;
}

.profile-info:hover .profile-arrow {
  transform: rotate(180deg);
}

/* Panel Content */
.panel-content {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

/* Welcome Section */
.welcome-section {
  margin-bottom: 3rem;
}

.welcome-card {
  background: white;
  border-radius: 25px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  position: relative;
  overflow: hidden;
}

.welcome-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.welcome-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
}

.welcome-card h2 {
  margin: 0 0 1rem 0;
  font-size: 2.5rem;
  color: #333;
  font-weight: 700;
}

.welcome-card p {
  margin: 0;
  color: #6c757d;
  font-size: 1.2rem;
  line-height: 1.6;
}

/* Action Section */
.action-section {
  margin-bottom: 3rem;
}

.action-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

.action-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: relative;
  overflow: hidden;
}

.action-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
}

.action-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.card-icon {
  font-size: 2.5rem;
  min-width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-content {
  flex: 1;
}

.card-content h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
  color: #333;
  font-weight: 600;
}

.card-content p {
  margin: 0;
  color: #6c757d;
  line-height: 1.5;
}

.card-arrow {
  font-size: 1.5rem;
  color: #6c757d;
  transition: transform 0.3s;
}

.action-card:hover .card-arrow {
  transform: translateX(5px);
  color: #4CAF50;
}

/* Appointments Section */
.appointments-section {
  background: white;
  border-radius: 25px;
  padding: 2.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.section-header {
  margin-bottom: 2rem;
  text-align: center;
}

.section-header h2 {
  margin: 0 0 0.5rem 0;
  font-size: 2rem;
  color: #333;
  font-weight: 700;
}

.section-stats {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.stat-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

/* Loading State */
.loading-state {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4CAF50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.empty-state h4 {
  margin: 0 0 0.5rem 0;
  color: #333;
  font-size: 1.2rem;
}

.empty-state p {
  margin: 0;
  color: #6c757d;
}

/* Appointments Grid */
.appointments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.appointment-card {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.appointment-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
}

.appointment-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.appointment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.lesson-icon {
  font-size: 2rem;
}

.appointment-status {
  display: flex;
  gap: 0.5rem;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-beklemede {
  background: #fff3cd;
  color: #856404;
}

.status-onaylandı {
  background: #d4edda;
  color: #155724;
}

.status-iptal {
  background: #f8d7da;
  color: #721c24;
}

.appointment-content {
  margin-bottom: 1.5rem;
}

.lesson-name {
  margin: 0 0 1rem 0;
  font-size: 1.3rem;
  color: #333;
  font-weight: 600;
}

.appointment-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.info-label {
  font-weight: 600;
  color: #495057;
  min-width: 120px;
}

.info-value {
  color: #333;
}

.appointment-actions {
  display: flex;
  justify-content: flex-end;
}

.btn-cancel {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

.btn-cancel:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

.btn-cancel.disabled {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  cursor: not-allowed;
  opacity: 0.7;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);
}

.btn-cancel.disabled:hover {
  transform: none;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);
}

.cancelled-text {
  color: #6c757d;
  font-style: italic;
  padding: 0.75rem 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.section-actions {
  text-align: center;
}

.btn-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
}





/* Responsive tasarım */
@media (max-width: 768px) {
  .panel-header {
    padding: 1.5rem 1rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .header-content h1 {
    font-size: 2rem;
  }
  
  .header-actions {
    margin-top: 0;
  }
  
  .panel-content {
    padding: 1rem;
  }
  
  .welcome-card {
    padding: 2rem 1.5rem;
  }
  
  .welcome-card h2 {
    font-size: 2rem;
  }
  
  .action-cards {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .action-card {
    padding: 1.5rem;
    flex-direction: column;
    text-align: center;
  }
  
  .appointments-grid {
    grid-template-columns: 1fr;
  }
  
  .appointments-section {
    padding: 1.5rem;
  }
  
  .profile-info {
    padding: 0.75rem 1rem;
  }
  
  .profile-avatar {
    width: 35px;
    height: 35px;
    font-size: 1rem;
    background: #667eea;
    color: white;
  }

  /* Mobilde accordion düzenlemeleri */
  .accordion-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .week-summary {
    flex-direction: column;
    gap: 0.5rem;
  }

  .accordion-content {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .panel-header {
    padding: 1rem 0.75rem;
    gap: 0.75rem;
  }
  
  .header-content h1 {
    font-size: 1.5rem;
  }
  
  .header-subtitle {
    font-size: 1rem;
  }
  
  .header-actions {
    margin-top: 0;
  }
  
  .welcome-card {
    padding: 1.5rem 1rem;
  }
  
  .welcome-card h2 {
    font-size: 1.5rem;
  }
  
  .welcome-card p {
    font-size: 1rem;
  }
  
  .action-card {
    padding: 1rem;
  }
  
  .appointments-section {
    padding: 1rem;
  }
}

/* Haftalık Accordion Stilleri */
.weekly-accordion {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.week-accordion-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #e0e0e0;
}

.accordion-header:hover {
  background: #e9ecef;
}

.week-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.week-number {
  font-weight: bold;
  color: #333;
  font-size: 1.1rem;
}

.week-date {
  color: #666;
  font-size: 0.9rem;
}

.week-summary {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.total-count {
  background: #4CAF50;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: bold;
  font-size: 0.9rem;
}

.accordion-arrow {
  font-size: 1.2rem;
  color: #666;
  transition: transform 0.3s ease;
}

.accordion-arrow.expanded {
  transform: rotate(180deg);
}

.accordion-content {
  background: white;
  padding: 1.5rem;
}

/* Çıkış Onay Popup Stilleri */
.logout-confirm-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  animation: fadeIn 0.3s ease-out;
}

.logout-confirm-popup {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  max-width: 500px;
  width: 90%;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.logout-confirm-popup-header {
  background: linear-gradient(135deg, #9c27b0, #673ab7);
  color: white;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.logout-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.logout-confirm-popup-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.logout-confirm-popup-body {
  padding: 2rem;
  text-align: center;
}

.logout-confirm-popup-body p {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
}

.logout-confirm-popup-actions {
  padding: 1.5rem 2rem 2rem;
  text-align: center;
  border-top: 1px solid #eee;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.logout-confirm-popup .btn-cancel {
  background: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.logout-confirm-popup .btn-cancel:hover {
  background: #e0e0e0;
  transform: translateY(-2px);
}

.btn-logout-confirm {
  background: linear-gradient(135deg, #9c27b0, #673ab7);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.3);
  min-width: 120px;
}

.btn-logout-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(156, 39, 176, 0.4);
}

.btn-logout-confirm:active {
  transform: translateY(0);
}

/* Animasyonlar */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { 
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to { 
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Mobil responsive */
@media (max-width: 768px) {
  .logout-confirm-popup {
    max-width: 90%;
    margin: 1rem;
  }
  
  .logout-confirm-popup-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  
  .logout-icon {
    font-size: 3rem;
  }
  
  .logout-confirm-popup-header h3 {
    font-size: 1.3rem;
  }
  
  .logout-confirm-popup-body {
    padding: 1.5rem;
  }
  
  .logout-confirm-popup-actions {
    padding: 1rem 1.5rem 1.5rem;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .logout-confirm-popup .btn-cancel,
  .btn-logout-confirm {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
    min-width: auto;
  }
}

/* Randevu İptal Onay Popup Stilleri */
.cancel-appointment-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  animation: fadeIn 0.3s ease-out;
}

.cancel-appointment-popup {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  max-width: 550px;
  width: 90%;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.cancel-appointment-popup-header {
  background: linear-gradient(135deg, #ff5722, #e64a19);
  color: white;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.cancel-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.cancel-appointment-popup-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.cancel-appointment-popup-body {
  padding: 2rem;
  text-align: center;
}

.appointment-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: left;
}

.appointment-info p {
  margin: 0.5rem 0;
  font-size: 1rem;
  color: #333;
}

.appointment-info strong {
  color: #555;
  font-weight: 600;
}

.cancel-appointment-popup-body .warning-text {
  color: #d32f2f !important;
  font-weight: 500;
  font-size: 1rem !important;
  background-color: #ffebee;
  padding: 1rem;
  border-radius: 8px;
  border-left: 4px solid #d32f2f;
  margin: 0;
}

.cancel-appointment-popup-actions {
  padding: 1.5rem 2rem 2rem;
  text-align: center;
  border-top: 1px solid #eee;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.cancel-appointment-popup .btn-cancel {
  background: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.cancel-appointment-popup .btn-cancel:hover {
  background: #e0e0e0;
  transform: translateY(-2px);
}

.btn-cancel-confirm {
  background: linear-gradient(135deg, #ff5722, #e64a19);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 87, 34, 0.3);
  min-width: 120px;
}

.btn-cancel-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 87, 34, 0.4);
}

.btn-cancel-confirm:active {
  transform: translateY(0);
}

/* Logo Responsive Tasarım */
@media (max-width: 1024px) {
  .header-logo {
    width: 300px;
    height: 78px;
  }
  
  .header-title-section h1 {
    font-size: 1.6rem;
  }
}

@media (max-width: 768px) {
  .panel-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
    padding: 1.5rem;
    min-height: auto;
  }
  
  .header-content {
    align-items: center;
    text-align: center;
  }
  
  .logo-section {
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
    justify-content: center;
    margin-left: 0;
  }
  
  .header-logo {
    width: 250px;
    height: 65px;
  }
  

  
  .header-subtitle {
    font-size: 0.9rem;
    text-align: center;
  }
  
  .header-actions {
    justify-content: center;
    margin-top: 0.5rem;
  }
  
  .profile-info {
    padding: 0.75rem 1rem;
    justify-content: center;
    width: fit-content;
    margin: 0 auto;
  }
  
  .profile-avatar {
    width: 35px;
    height: 35px;
    font-size: 1rem;
    background: #667eea;
    color: white;
  }
  
  .profile-name {
    font-size: 0.9rem;
  }
  
  .profile-role {
    font-size: 0.8rem;
  }
  
  /* Mevcut mobil CSS */
  .cancel-appointment-popup {
    max-width: 90%;
    margin: 1rem;
  }
  
  .cancel-appointment-popup-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  
  .cancel-icon {
    font-size: 3rem;
  }
  
  .cancel-appointment-popup-header h3 {
    font-size: 1.3rem;
  }
  
  .cancel-appointment-popup-body {
    padding: 1.5rem;
  }
  
  .appointment-info {
    padding: 1rem;
  }
  
  .cancel-appointment-popup-actions {
    padding: 1rem 1.5rem 1.5rem;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .cancel-appointment-popup .btn-cancel,
  .btn-cancel-confirm {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
    min-width: auto;
  }
}

/* Panel Header Responsive Tasarım */

/* Tablet (≤1024px) */
@media (max-width: 1024px) {
  .panel-header {
    padding: 1.5rem 1.5rem;
  }
  
  .header-logo {
    width: 400px;
    height: 104px;
  }
  

  
  .header-subtitle {
    font-size: 0.95rem;
  }
  
  .profile-info {
    padding: 0.875rem 1.25rem;
  }
  
  .profile-avatar {
    width: 38px;
    height: 38px;
    font-size: 1.1rem;
  }
  
  .profile-name {
    font-size: 0.95rem;
  }
  
  .profile-role {
    font-size: 0.85rem;
  }
}

/* Küçük Mobil (≤480px) */
@media (max-width: 480px) {
  .panel-header {
    padding: 1rem;
    gap: 0.75rem;
    min-height: auto;
  }
  
  .header-logo {
    width: 400px;
    height: 120px;
  }
  

  
  .header-subtitle {
    font-size: 0.8rem;
  }
  
  .profile-info {
    padding: 0.5rem 0.75rem;
    gap: 0.75rem;
  }
  
  .profile-avatar {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
    background: #667eea;
    color: white;
  }
  
  .profile-name {
    font-size: 0.8rem;
  }
  
  .profile-role {
    font-size: 0.7rem;
  }
}

/* Ekstra Küçük Mobil (≤360px) */
@media (max-width: 360px) {
  .panel-header {
    padding: 0.75rem;
    gap: 0.5rem;
  }
  
  .header-logo {
    width: 250px;
    height: 80px;
  }
  

  
  .header-subtitle {
    font-size: 0.75rem;
  }
  
  .profile-info {
    padding: 0.5rem 0.5rem;
    gap: 0.5rem;
  }
  
  .profile-avatar {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }
  
  .profile-name {
    font-size: 0.75rem;
  }
  
  .profile-role {
    font-size: 0.65rem;
  }
}
</style>

